import { AxiosError, AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { DelegeeFileType } from "./DelegeeFileType.enum";
import { triggerBlobDownload } from "../../utils/downloadBlob";

interface DownloadFileProps {
    readonly downloadValidationRequest: (seasonTicketOwnerCrmId : string, fileReference: string, language: string) => Promise<AxiosResponse<Blob>>;
    readonly downloadInvitationRequest: (seasonTicketOwnerCrmId : string, fileReference: string, language: string) => Promise<AxiosResponse<Blob>>;
    readonly onError: (error: string) => void;
    readonly getFileName: () => string;
    readonly getSeasonTicketOwnerCrmId: () => string;
    readonly getFileReference: () => string;
    readonly getLanguage: () => string | undefined;
    readonly delegeeFileType: DelegeeFileType;
}

interface DownloadedFileInfo {
    readonly download: () => Promise<void>;
}

export const useDownloadFile = ({
    downloadValidationRequest,
    downloadInvitationRequest,
    onError,
    getFileName,
    getSeasonTicketOwnerCrmId,
    getFileReference,
    getLanguage,
    delegeeFileType
}: DownloadFileProps): DownloadedFileInfo => {

    let downloadRequest = delegeeFileType === DelegeeFileType.Invitation 
        ? downloadInvitationRequest(getSeasonTicketOwnerCrmId(), getFileReference(), getLanguage()!) 
        : downloadValidationRequest(getSeasonTicketOwnerCrmId(), getFileReference(), getLanguage()!);
    

    const { t } = useTranslation(["downloadFile"]);
    const download = () => downloadRequest
        .then((response: AxiosResponse<Blob>) => {
            const data = response.data;
            if (data.size === 0) {
                onError(t("invalidFileReference"));
            }
            else {
                triggerBlobDownload(data, getFileName());
            }            
        })
        .catch((error: AxiosError) => {
            if (error.response?.status === 400) {
                onError(t("invalidFileReference"));
            }
            else {
                onError(error.message);
            }            
        })

    return { download };
};
